/**
 * @author Daniel Vítek danielvitek1@gmail.com danvitek.cz
 * @license [MIT](http://www.opensource.org/licenses/mit-license.php)
 */
(function ($) {
	'use strict';

	$.sceditor.locale['cs'] = {
		'Bold': 'Tučné',
		'Italic': 'Kurzíva',
		'Underline': 'Podtržené',
		'Strikethrough': 'Přeškrtnuté',
		'Subscript': 'Dolní index',
		'Superscript': 'Horní index',
		'Align left': 'Zarovnat vlevo',
		'Center': 'Zarovnat na střed',
		'Align right': 'Zarovnat vpravo',
		'Justify': 'Zarovnat do bloku',
		'Font Name': 'Výběr písma',
		'Font Size': 'Velikost písma',
		'Font Color': 'Barva písma',
		'Remove Formatting': 'Vymazat formátování',
		'Cut': 'Vyjmout',
		'Your browser does not allow the cut command. Please use the keyboard shortcut Ctrl/Cmd-X': 'Váš prohlížeč nepodporuje tento příkaz, použijte CTRL+X',
		'Copy': 'Kopírovat',
		'Your browser does not allow the copy command. Please use the keyboard shortcut Ctrl/Cmd-C': 'Váš prohlížeč nepodporuje tento příkaz, použijte CTRL+C',
		'Paste': 'Vložit',
		'Your browser does not allow the paste command. Please use the keyboard shortcut Ctrl/Cmd-V': 'Váš prohlížeč nepodporuje tento příkaz, použijte CTRL+V',
		'Paste your text inside the following box:': 'Vložte Váš text do následujícího pole',
		'Paste Text': 'Vložit text',
		'Bullet list': 'Seznam',
		'Numbered list': 'Číslovaný seznam',
		'Undo': 'Zpět',
		'Redo': 'Vpřed',
		'Rows:': 'Řádků',
		'Cols:': 'Buněk',
		'Insert a table': 'Vložit tabulku',
		'Insert a horizontal rule': 'Vložit vodorovnou čáru',
		'Code': 'Vložit kód',
		'Width (optional):': 'Šířka (volitelné)',
		'Height (optional):': 'Výška (volitelné)',
		'Insert an image': 'Vložit obrázek',
		'E-mail:': 'E-mailová adresa',
		'Insert an email': 'Vložit e-mail',
		'URL:': 'Adresa',
		'Insert a link': 'Vložit odkaz',
		'Unlink': 'Zrušit odkaz',
		'More': 'Více',
		'Insert an emoticon': 'Vložit smajlíka',
		'Video URL:': 'Adresa videa',
		'Insert': 'Vložit',
		'Insert a YouTube video': 'Vložte video z YouTube',
		'Insert current date': 'Vložte aktuální datum',
		'Insert current time': 'Vložte aktuální čas',
		'Print': 'Vytisknout',
		'View source': 'Zobrazit zdroj',
		'Description (optional):': 'Popis (volitelné)',
		'Enter the image URL:': 'Vložte adresu obrázku',
		'Enter the e-mail address:': 'Vložte e-mailovou adresu',
		'Enter the displayed text:': 'Vložte zobrazovaný text',
		'Enter URL:': 'Vložte adresu',
		'Enter the YouTube video URL or ID:': 'Vložte adresu YouTube videa nebo ID videa',
		'Insert a Quote': 'Vložit citát',
		'Invalid YouTube video': 'Neplatné YouTube video',
		'Add indent': 'Posunout na další úroveň',
		'Remove one indent': 'Posunout na předchozí úroveň',
		'Maximize': 'Zobrazit přes celou obrazovku',

		dateFormat: 'day-month-year'
	};
})(jQuery);
